// extracted by mini-css-extract-plugin
export default {"root":"Kro7QU_5","divider":"P1mQOR1E","googleButtonShell":"H4ckCUDq","googleButton":"quMkxJSC","googleButtonFallback":"Ean2zIBV","googleIcon":"RTE0B5v7"};